'use strict';

const absTimeDuration = (timeDuration) => {
  return {
    days: timeDuration.days ? Math.abs(timeDuration.days) : void 0,
    hours: timeDuration.hours ? Math.abs(timeDuration.hours) : void 0,
    minutes: timeDuration.minutes ? Math.abs(timeDuration.minutes) : void 0,
    seconds: timeDuration.seconds ? Math.abs(timeDuration.seconds) : void 0,
    milliseconds: timeDuration.milliseconds ? Math.abs(timeDuration.milliseconds) : void 0
  };
};

module.exports = absTimeDuration;
//# sourceMappingURL=absTimeDuration.cjs.map
